module.exports = __webpack_public_path__ + "4f44077586ec12a35ce6778e879d43da.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/ExtraBoldItalic/OpenSans-ExtraBoldItalic.woff?v=1.1.0
// module id = 1019
// module chunks = 0